import React, { Component } from "react";
import _ from "lodash";
import { setCache, TranslateListing } from "../../utils/consts";
import firebase from "./../../utils/firebase";
import geohash from "ngeohash";

import { SearchParams } from "../../utils/consts";

import ReactMapboxGl, { Marker, Popup, ZoomControl } from "react-mapbox-gl";

import Search from "./Search";
import MapBoxPin from "../../components/mapBoxPin/MapBoxPin";
import MapBoxPinPopup from "../../components/mapBoxPinPopup/MapBoxPinPopup";
import SkeletonText from "../../components/skeleton/SkeletonText";

import Pagination from "@atlaskit/pagination";

import "./searchMap.css";

import ImagesUnavailable from "../../assets/no_image_available.png";

const QueryDictionary = {
  beds: "Physical_Properties.Beds",
  baths: "Physical_Properties.Baths",
  parking: "Parking.TotalParking",
  furnished: "Furnished",
  locker: "Locker"
};

const Map = ReactMapboxGl({
  accessToken:
    "pk.eyJ1IjoiZ3VhcmVudGVlIiwiYSI6ImNqbHVib2VtaTBrNGszdW14aTZiOGduaGUifQ.S7ukvYQ4-Dz5b3zaUNONEQ",
  // minZoom: 12,
  attributionControl: false,
  logoPosition: "bottom-right"
});

export default class SearchMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listings: [],
      beds: 1,
      baths: 1,
      parking: 1,
      furnished: false,
      minexpense: 2000,
      maxexpense: 3000,
      center: [-79.3877, 43.6809]
    };
  }

  componentDidMount() {
    this.setSearchFromParams();
    // this.getLocation();
  }

  // getLocation = () => {
  //   GetLocation()
  //     .then(res => {
  //       const coords = res.coords || {};
  //       const lng = coords.longitude;
  //       const lat = coords.latitude;
  //       const center = [lng, lat];
  //       const zoom = 15;
  //       if (!!lng && !!lat) {
  //         this.setState({ zoom, center });
  //       }
  //     })
  //     .catch(err => console.log(err));
  // };

  setSearchFromParams = () => {
    if (this.props.location && this.props.location.search) {
      const string = this.props.location.search || "";
      const params = new URLSearchParams(string);
      const values = {};
      Object.keys(SearchParams)
        .filter(key => !!params.get(key))
        .forEach(key => {
          const value = params.get(key);
          if (SearchParams[key] === "number" && (!!value || value === 0)) {
            values[key] = parseInt(value, 10);
          }
          if (SearchParams[key] === "boolean" && (!!value || value === 0)) {
            values[key] = value === "true" ? true : false;
          }
        });
      const search = params.get("search");
      search === "true" || search === true
        ? this.setState({ ...values }, this.search)
        : this.setState({ ...values });
    }
  };

  findCommonGeohash = bounds => {
    const { _sw, _ne } = bounds;
    const listings = this.state.listings || [];
    const inBoundListings = listings.filter(listing => {
      const location = listing.location || {};
      const lat = location.lat;
      const lng = location.lng;
      return _sw.lat < lat && lat < _ne.lat && _sw.lng < lng && lng < _ne.lng;
    });
    console.log(inBoundListings);
    this.setState({ results: inBoundListings });
    // console.log(bounds);
    // const tl = [_sw["lng"], _ne["lat"]];
    // const tr = [_ne["lng"], _ne["lat"]];
    // const bl = [_sw["lng"], _sw["lat"]];
    // const br = [_ne["lng"], _sw["lat"]];
    // const tlg = geohash.encode(tl[1], tl[0]).split("");
    // const trg = geohash.encode(tr[1], tr[0]).split("");
    // const blg = geohash.encode(bl[1], bl[0]).split("");
    // const brg = geohash.encode(br[1], br[0]).split("");
    // const area = tlg
    //   .filter(
    //     (char, i) => char === trg[i] && char === blg[i] && char === brg[i]
    //   )
    //   .join("");
    // console.log(area);
  };

  search = async () => {
    this.setState({
      searching: true,
      results: [],
      pages: null,
      page: null,
      popupInfo: null
    });
    try {
      const maxexpense = this.state.maxexpense || 99999;
      const minexpense = this.state.minexpense || 0;
      // const minsize = this.state.minsize || 600;
      const queries = ["beds", "baths", "parking", "furnished", "locker"];
      const selected = queries.filter(
        item => !!this.state[item] || this.state[item] === 0
      );
      const collection = firebase.firestore().collection("listings");

      let query = collection
        .where("Expense.Rent_Expense", "<=", maxexpense)
        .where("Expense.Rent_Expense", ">=", minexpense);
      // query = query.where("Physical_Properties.Footage_Cat");
      selected.forEach(item => {
        query = query.where(QueryDictionary[item], "==", this.state[item]);
      });

      const listings = this.state.listings || [];
      const results = [];
      const querySnapshot = await query
        .orderBy("Expense.Rent_Expense", "asc")
        .limit(50)
        .get()
        .catch(error => console.log(error));

      // const last = querySnapshot.docs[querySnapshot.docs.length - 1];
      // this.setState({ last });

      if (querySnapshot.empty) {
        this.props.addFlag({
          appearance: 0,
          title: "No Results - Try Again"
        });
        this.setState({ searching: false, results: [] });
      } else {
        this.setState({ pages: Math.ceil(querySnapshot.size / 30), page: 1 });
        querySnapshot.forEach(async doc => {
          const listing = doc.data();
          listings.push(listing);
          this.setState(() => ({ listings }));
          setCache(listing.Listing_ID, listing, "listings").catch(e => e);
          const result = await TranslateListing(listing);
          //filter out results that don't have location lat and lng
          if (
            result.location &&
            !!result.location.lat &&
            !!result.location.lng
          ) {
            results.push(result);
          }
          this.setState(() => ({ results, searching: false }));
        });
      }
    } catch (error) {
      console.log(error);
      this.props.addFlag({
        appearance: 2,
        title: "Error - Please Try Again"
      });
      this.setState({ searching: false });
    }
  };

  _renderPopup = () => {
    const { popupInfo } = this.state;
    return (
      popupInfo && (
        <Popup
          tipSize={5}
          closeOnClick={true}
          closeButton={true}
          offsetTop={-250}
          offsetLeft={-25}
          dynamicPosition={true}
          coordinates={[popupInfo.location.lng, popupInfo.location.lat]}
          onClose={() => this.setState({ popupInfo: null })}
        >
          <MapBoxPinPopup
            onClose={() => this.setState({ popupInfo: null })}
            info={popupInfo}
          />
        </Popup>
      )
    );
  };

  _renderMapBoxMarker = (item, index) => {
    return (
      <Marker
        key={`marker-${index}`}
        coordinates={[item.location.lng, item.location.lat]}
        longitude={item.location.lng}
        latitude={item.location.lat}
      >
        <MapBoxPin
          size={20}
          onClick={() =>
            this.setState({
              popupInfo: item
              // center: [item.location.lng, item.location.lat]
            })
          }
        />
      </Marker>
    );
  };

  handleFilter = (i, item, newSelection) =>
    this.setState({ [`${item}`]: !newSelection ? i : null });

  handleMapClick = () => this.setState({ popupInfo: null });

  render() {
    // console.log(this.state);
    return (
      <React.Fragment>
        <div className="search-container">
          <Search
            value={this.state}
            handleFilter={this.handleFilter}
            searching={this.state.searching}
            search={this.search}
          />
        </div>
        <div className="searchmap">
          <div className="search-list">
            {this.state.searching
              ? _.times(30, "loading").map((e, i) => (
                  <div
                    key={`skeleton__search-result-${i}`}
                    className="search-list-result search-list-result__loading"
                  >
                    <SkeletonText lines={1} />
                  </div>
                ))
              : !!this.state.results && (
                  <div className="search-list__results">
                    {this.state.results
                      .filter(
                        (r, i) =>
                          i < this.state.page * 30 &&
                          i >= (this.state.page - 1) * 30
                      )
                      .map((result, i) => (
                        <div
                          className="search-list-result"
                          key={`search-result__${i}`}
                          onClick={() => {
                            this.setState({
                              popupInfo: result,
                              center: [result.location.lng, result.location.lat]
                            });
                          }}
                        >
                          <div
                            className="search-list-result__image"
                            style={{
                              backgroundImage: !!result.preview
                                ? `url(data:image/jpeg;base64,${
                                    result.preview
                                  })`
                                : `url(${ImagesUnavailable})`
                            }}
                          />
                          <div className="search-list-result__details">
                            <p className="search-list-result__title">
                              {result.title}
                            </p>
                            {result.expense && (
                              <p className="search-list-result__expense">
                                ${result.expense.rentExpense}
                              </p>
                            )}
                            {result.physicalProperties &&
                              result.physicalProperties.footage && (
                                <p className="search-list-result__expense">
                                  {result.physicalProperties.footage} sqft
                                </p>
                              )}
                          </div>
                        </div>
                      ))}
                  </div>
                )}
            {this.state.results && this.state.page && (
              <div className="search-pagination-container">
                <Pagination
                  id="search-pagination"
                  i18n={{ prev: "<", next: ">" }}
                  defaultValue={1}
                  value={this.state.page}
                  total={this.state.pages}
                  onChange={page => this.setState({ page, popupInfo: null })}
                />
              </div>
            )}
          </div>
          <div className="search-map-container">
            <Map
              // fitBounds={
              //   this.state.results && !!this.state.results.length
              //     ? [
              //         [
              //           this.state.results
              //             .map(result => result.location || {})
              //             .map(loc => loc.lng)
              //             .filter(loc => !!loc)
              //             .reduce(
              //               (a, b) => (a < b ? a : b),
              //               this.state.center[0]
              //             ) - 0.02,
              //           this.state.results
              //             .map(result => result.location || {})
              //             .map(loc => loc.lat)
              //             .filter(loc => !!loc)
              //             .reduce(
              //               (a, b) => (a < b ? a : b),
              //               this.state.center[1]
              //             ) - 0.02
              //         ],
              //         [
              //           this.state.results
              //             .map(result => result.location || {})
              //             .map(loc => loc.lng)
              //             .filter(loc => !!loc)
              //             .reduce(
              //               (a, b) => (a > b ? a : b),
              //               this.state.center[0]
              //             ) + 0.02,
              //           this.state.results
              //             .map(result => result.location || {})
              //             .map(loc => loc.lat)
              //             .filter(loc => !!loc)
              //             .reduce(
              //               (a, b) => (a > b ? a : b),
              //               this.state.center[1]
              //             ) + 0.02
              //         ]
              //       ]
              //     : null
              // }
              onClick={this.handleMapClick}
              // geolocateControl={true}
              onMoveEnd={map => {
                console.log(map);
                if (!map._zooming) {
                  this.findCommonGeohash(map.getBounds());
                }
              }}
              className="search-map"
              // eslint-disable-next-line
              // style="mapbox://styles/mapbox/basic-v9"
              // eslint-disable-next-line
              style="mapbox://styles/mapbox/light-v9"
              // style="mapbox://styles/mapbox/satellite-streets-v10"
              // style="mapbox://styles/mapbox/dark-v9"
              containerStyle={{
                height: "100%",
                width: "100%"
              }}
              center={
                this.state.center
                // !!this.state.popupInfo
                //   ? [
                //       this.state.popupInfo.location.lng,
                //       this.state.popupInfo.location.lat
                //     ]
                //   : this.state.center
              }
              // maxBounds={[[-81.124358, 43.067973], [-77.685491, 45.438995]]}
              zoom={this.state.zoom}
              zoomControl={true}
            >
              {this.state.results &&
                this.state.results
                  .filter(
                    (r, i) =>
                      i < this.state.page * 30 &&
                      i >= (this.state.page - 1) * 30
                  )
                  .map(this._renderMapBoxMarker)}
              {this.state.popupInfo && this._renderPopup()}
              <ZoomControl />
            </Map>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

// {
//   {
//     this.state.page > 1
//     ? `${this.state.page - 1}${i + 1}. `
//     : `${i + 1}. `
//   }}



// WEBPACK FOOTER //
// ./src/components/SearchMap/SearchMap.js